import { useState } from "react";
import { useAuth, useLoad } from "../lib/api.jsx";
import { Wait, Tbl, Pager, Modal, F, day } from "../lib/ui.jsx";

const fresh = () => ({
  name: "", domain: "", db_host: "", db_name: "", db_user: "", db_pass: "",
  storage_path: "", portal: "", status: "active",
});

export default function Portals() {
  const { act } = useAuth();
  const [f, setF] = useState({ search: "", status: "", page: 1, per: 20 });
  const [d, reload] = useLoad("portals", f);
  const [e, setE] = useState(null);

  const open = (p) => setE(p ? { ...fresh(), ...p, db_pass: "" } : fresh());
  const save = async () => { if (await act("portal_save", e, "Portal saved.")) { setE(null); reload(); } };
  const del = (p) => {
    if (confirm(`Delete ${p.name}? This only works if no permissions or packages are attached to it.`)) {
      act("portal_delete", { id: p.id }, "Portal deleted.").then(reload);
    }
  };

  return (
    <>
      <h1>Portals</h1>
      <p className="muted">Suspending a portal is recorded here; make sure each portal app checks this status. Database credentials are write-only — never shown once saved.</p>
      <div className="bar">
        <input placeholder="Search name, domain, portal code" value={f.search} onChange={(e2) => setF({ ...f, search: e2.target.value, page: 1 })} />
        <select value={f.status} onChange={(e2) => setF({ ...f, status: e2.target.value, page: 1 })}>
          <option value="">Any status</option><option value="active">Active</option><option value="suspended">Suspended</option>
        </select>
        <button className="btn" onClick={() => open()}>Add new</button>
      </div>
      <Wait d={d}>
        {d && !d.error && (
          <>
            <Tbl rows={d.rows} empty="No portals match. Clear the filters or add one." onRowClick={open} cols={[
              ["Name", (p) => p.name], ["Domain", (p) => p.domain], ["Portal code", (p) => p.portal || "-"],
              ["Members", (p) => p.members], ["Added", (p) => day(p.created_at)],
              ["Status", (p) => (
                <select value={p.status} onChange={(e2) => act("portal_status", { id: p.id, status: e2.target.value }, "Portal updated.").then(reload)}>
                  <option value="active">Active</option><option value="suspended">Suspended</option>
                </select>
              )],
              ["", (p) => (
                <>
                  <button className="btn g s" onClick={() => open(p)}>Edit</button>{" "}
                  <button className="btn d s" onClick={() => del(p)}>Delete</button>
                </>
              )],
            ]} />
            <Pager f={f} setF={setF} d={d} />
          </>
        )}
      </Wait>

      {e && (
        <Modal title={e.id ? `Edit ${e.name}` : "Add portal"} onClose={() => setE(null)}>
          <div className="g2">
            <F label="Name *" v={e.name} set={(v) => setE({ ...e, name: v })} />
            <F label="Domain *" v={e.domain} set={(v) => setE({ ...e, domain: v })} />
            <F label="Portal code (used as c_refer elsewhere)" v={e.portal} set={(v) => setE({ ...e, portal: v })} />
            <div>
              <label>Status</label>
              <select value={e.status} onChange={(x) => setE({ ...e, status: x.target.value })}>
                <option value="active">Active</option><option value="suspended">Suspended</option>
              </select>
            </div>
          </div>
          <F label="Storage path" v={e.storage_path} set={(v) => setE({ ...e, storage_path: v })} />
          <h2 style={{ fontSize: 14, margin: "14px 0 2px" }}>Database connection</h2>
          <div className="g2">
            <F label="DB host *" v={e.db_host} set={(v) => setE({ ...e, db_host: v })} />
            <F label="DB name *" v={e.db_name} set={(v) => setE({ ...e, db_name: v })} />
            <F label="DB user *" v={e.db_user} set={(v) => setE({ ...e, db_user: v })} />
            <F label={e.id ? "DB password (leave blank to keep current)" : "DB password *"} type="password" v={e.db_pass} set={(v) => setE({ ...e, db_pass: v })} />
          </div>
          <div className="bar"><button className="btn" onClick={save}>{e.id ? "Save changes" : "Add portal"}</button></div>
        </Modal>
      )}
    </>
  );
}
